import React, {useState} from 'react';
import {Popover, Button, FormLayout, TextField} from "@shopify/polaris";
import moment from 'moment';

import {OffsetDateTime} from "../services/CommonModel";
import DateRangeDescription from "./DateRangeDescription";

type DateTimeRangePopoverProps = {
    from: OffsetDateTime,
    to: OffsetDateTime,
    onChange: (from:OffsetDateTime, to:OffsetDateTime) => void
}

const DateTimeRangePopover = ({from, to, onChange} : DateTimeRangePopoverProps) => {
    const [popoverActive, setPopoverActive] = useState(false);

    const [enteredDate, setEnteredDate] = useState(moment(from).format("YYYY-MM-DD"));
    const [invalidDateErrorMessage, setInvalidDateErrorMessage] = useState<string | undefined>(undefined);

    const [enteredFromTime, setEnteredFromTime] = useState(moment(from).format("HH:mm"));
    const [invalidFromTimeErrorMessage, setInvalidFromTimeErrorMessage] = useState<string | undefined>(undefined);

    const [enteredToTime, setEnteredToTime] = useState(moment(to).format("HH:mm"));
    const [invalidToTimeErrorMessage, setInvalidToTimeErrorMessage] = useState<string | undefined>(undefined);

    const onDateChanged = (dateVal:string) => {
        const mFrom = moment(dateVal + " " + enteredFromTime + ":00");
        if (mFrom.isValid()) {
            setInvalidDateErrorMessage(undefined);
            setEnteredDate(dateVal);
        } else {
            setInvalidDateErrorMessage("Invalid Date");
        }
    }

    const onFromTimeChanged = (timeVal:string) => {
        const mFrom = moment(enteredDate + " " + timeVal + ":00");
        if (mFrom.isValid()) {
            setInvalidFromTimeErrorMessage(undefined);
            setEnteredFromTime(timeVal);
        } else {
            setInvalidFromTimeErrorMessage("Invalid Time");
        }
    }

    const onToTimeChanged = (timeVal:string) => {
        const mTo = moment(enteredDate + " " + timeVal + ":00");
        if (mTo.isValid()) {
            setInvalidToTimeErrorMessage(undefined);
            setEnteredToTime(timeVal);
        } else {
            setInvalidToTimeErrorMessage("Invalid Time");
        }
    }

    const onSaveClicked = () => {
        const mFrom = moment(enteredDate + " " + enteredFromTime + ":00");
        const mTo = moment(enteredDate + " " + enteredToTime + ":00");
        onChange(mFrom.toISOString(), mTo.toISOString());
        setPopoverActive(false);
    }


    /* @ts-ignore */
    return (
        <Popover
            active={popoverActive}
            sectioned
            activator={(
                <Button
                    fullWidth
                    disclosure
                    textAlign="left"
                    onClick={() => setPopoverActive((popoverActive) => !popoverActive)}
                >
                    {/* TS2322: Type 'Element' is not assignable to type 'string | string[] | undefined'. - NFI
                    // @ts-ignore */}
                    <DateRangeDescription from={from} to={to} />
                </Button>
            )}
            autofocusTarget="first-node"
            onClose={() => setPopoverActive(false)}
        >
            <FormLayout>
                <TextField
                    label="Date"
                    type="date"
                    clearButton={false}
                    value={enteredDate}
                    onChange={onDateChanged}
                    error={invalidDateErrorMessage}
                    autoComplete="off"
                />
                <TextField
                    label="From"
                    type="time"
                    clearButton={false}
                    value={enteredFromTime}
                    onChange={onFromTimeChanged}
                    error={invalidFromTimeErrorMessage}
                    autoComplete="off"
                />
                <TextField
                    label="To"
                    type="time"
                    clearButton={false}
                    value={enteredToTime}
                    onChange={onToTimeChanged}
                    error={invalidToTimeErrorMessage}
                    autoComplete="off"
                />
                <Button size="slim" onClick={onSaveClicked}>Save</Button>
            </FormLayout>
        </Popover>
    )
};

export default DateTimeRangePopover;